// extracted by mini-css-extract-plugin
export default {"overlay":"_1Ncls","modalRoot":"_3YTbJ","root":"_3JbMn","closeIcon":"_30zOO","title":"_19W-C","description":"_1r2F9","channels":"_2OyHO","emptyChannels":"_5GLP7","channel":"_3qmEo"};